var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { useQuery, useMutation } from "react-query";
import { queryClient } from "frontend/src/domain/query-client";
import { Box, Button, Link, Paper, IconButton, Tooltip, } from "@material-ui/core";
import ContentCopyIcon from '@material-ui/icons/TextFields';
import { searchMusicArchives, deleteMusicArchive, createMusicArchive, } from "frontend/src/api/music-archives";
var useSearchPlaylistMusicArchive = function (params) {
    var _a = useQuery(['music-archive', params], function () {
        return searchMusicArchives(params);
    }), data = _a.data, isLoading = _a.isLoading;
    return { data: data, isLoading: isLoading };
};
export var useCreatePlaylistMusicArchive = function (params) {
    var mutation = useMutation(function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, createMusicArchive(params)];
        });
    }); }, {
        onSettled: function () {
            queryClient.invalidateQueries('music-archives');
        }
    });
    return {
        run: mutation.mutate,
        isLoading: mutation.isLoading,
        isSuccess: mutation.isSuccess,
        data: mutation.data,
    };
};
export var useDeletePlaylistMusicArchive = function (params) {
    var mutation = useMutation(function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, deleteMusicArchive(params)];
        });
    }); }, {
        onSettled: function () {
            queryClient.invalidateQueries('music-archives');
        }
    });
    return {
        run: mutation.mutate,
        isLoading: mutation.isLoading,
        isSuccess: mutation.isSuccess,
        data: mutation.data,
    };
};
export var MusicArchive = function (_a) {
    var _b;
    var playlistId = _a.playlistId;
    var _c = React.useState(playlistId), searchPlaylistId = _c[0], setSearchPlaylistId = _c[1];
    var _d = useSearchPlaylistMusicArchive({ playlistId: searchPlaylistId }), data = _d.data, isLoading = _d.isLoading;
    var createHandle = useCreatePlaylistMusicArchive({ playlistId: playlistId });
    var _e = React.useState(-1), refreshTimer = _e[0], setRefreshTimer = _e[1];
    var status = isLoading
        ? 'loading'
        : ((data == undefined || data.total == 0)
            ? 'does-not-exist'
            : 'exists');
    var archive = (data == undefined || data.total == 0)
        ? null
        : data.items[0];
    var deleteHandle = useDeletePlaylistMusicArchive({ musicArchiveId: (_b = archive === null || archive === void 0 ? void 0 : archive.id) !== null && _b !== void 0 ? _b : -1 });
    var refresh = function (delay) {
        if (delay === void 0) { delay = 0; }
        if (playlistId == -1 || refreshTimer > 0) {
            return;
        }
        var timer = setTimeout(function () {
            setSearchPlaylistId(-1);
            setTimeout(function () {
                setSearchPlaylistId(playlistId);
                setRefreshTimer(-1);
            }, 1);
        }, delay);
        setRefreshTimer(+timer);
    };
    var doCreate = function () {
        createHandle.run({ playlistId: playlistId });
        setSearchPlaylistId(-1);
        refresh(500);
    };
    var doDelete = function () {
        var _a;
        deleteHandle.run({ musicArchiveId: (_a = archive === null || archive === void 0 ? void 0 : archive.id) !== null && _a !== void 0 ? _a : -1 });
        setSearchPlaylistId(-1);
        refresh();
    };
    var _f = React.useState(false), copied = _f[0], setCopied = _f[1];
    var copyOpenHandler = function (link) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, navigator.clipboard.writeText(link)];
                case 1:
                    _a.sent();
                    setCopied(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var copyCloseHandler = function () {
        setCopied(false);
    };
    var archiveControl;
    if (archive) {
        if (archive.is_ready) {
            archiveControl = (React.createElement(Box, { component: Paper, p: 2 },
                React.createElement(Box, { display: "flex", justifyContent: "space-between" },
                    React.createElement(Box, null,
                        React.createElement(Button, { variant: "outlined" },
                            React.createElement(Link, { color: "inherit", underline: "none", href: "/api/v2/music-archives/" + archive.id + "/download" }, "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0430\u0440\u0445\u0438\u0432")),
                        React.createElement(Tooltip, { open: copied, leaveDelay: 2000, title: "Ссылка на архив сохранена в буфер обмена", placement: "bottom", onClose: function () { return copyCloseHandler(); } },
                            React.createElement(IconButton, { onClick: function () { return copyOpenHandler("/api/v2/music-archives/" + archive.id + "/download"); } },
                                React.createElement(ContentCopyIcon, null)))),
                    React.createElement(Button, { color: "secondary", onClick: function () { return confirm('Вы точно хотите удалить этот архив?') && doDelete(); } }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0430\u0440\u0445\u0438\u0432"))));
        }
        else if (archive.is_processing) {
            archiveControl = (React.createElement(Box, null, "\u0410\u0440\u0445\u0438\u0432 \u0441\u043E\u0437\u0434\u0430\u0451\u0442\u0441\u044F, \u044D\u0442\u043E \u043C\u043E\u0436\u0435\u0442 \u0437\u0430\u043D\u044F\u0442\u044C \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u043C\u0438\u043D\u0443\u0442"));
            refresh(500);
        }
        else {
            archiveControl = (React.createElement(Box, null, "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0430\u0440\u0445\u0438\u0432\u0430 \u0437\u0430\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0438 \u0434\u043E\u043B\u0436\u043D\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C\u0441\u044F \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u043C\u0438\u043D\u0443\u0442"));
            refresh(500);
        }
    }
    return (React.createElement(Box, null, status == 'does-not-exist'
        ? (React.createElement(Button, { variant: "contained", color: "primary", onClick: function () { return doCreate(); } }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0430\u0440\u0445\u0438\u0432"))
        : (status == 'exists' && archive
            ? archiveControl : '')));
};
